import {Box} from "@mui/material";

const DonatePage=()=>{
    return(
        <Box>donate</Box>
    )
}
export default DonatePage
